<div class="dialog-content-container p-4">
    <div class="flex flex-column gap-4">
        <!-- Warning icon and message -->
        <div class="flex gap-3 align-items-center">
            <div class="flex-shrink-0">
                <i class="pi pi-exclamation-triangle text-3xl text-yellow-500"></i>
            </div>
            <div class="flex-grow-1">
                <h3 class="m-0 mb-2">{{ 'DUPLICATE_QUOTE.WARNING_TITLE' | translate }}</h3>
                <p class="m-0 text-secondary">{{ 'DUPLICATE_QUOTE.WARNING_MESSAGE' | translate }}</p>
            </div>
        </div>

        <!-- Actions -->
        <div class="flex justify-content-end gap-2 mt-3">
            <p-button [label]="'DUPLICATE_QUOTE.BTN_CREATE_VERSION' | translate" severity="secondary" (onClick)="onCreateVersion()" />
            <p-button [label]="'DUPLICATE_QUOTE.BTN_CONFIRM_DUPLICATE' | translate" (onClick)="onConfirmDuplicate()" />
        </div>
    </div>
</div>
